import { UserStoreController } from './UserStoreController';
import { useAuthSDK } from '~/features/auth-sdk';
import { usePopups } from '@mm-frontend/mm-web-ui-kit';
import type { IUserMM } from '~/entities/user/models/IUserMM';
import FillProfilePopup from '../ui/FillProfilePopup.vue';
import { UserService } from '~/shared/api/magnit-id/user/UserSerivce';
import { CuscomService } from '~/shared/api/mm-gateway/cuscom/CuscomService';
import { MMCoreBffClient } from '@/shared/api';
import { mapMarketCustomer } from '../mappers/UserMapper';
import { useAuthTracker } from '~/features/clickstream-sdk/trackers/useAuthTracker';

const { authSDKController, onAuth, onInit, onLogout } = useAuthSDK();
const userService = new UserService(authSDKController);
const cuscomService = new CuscomService();

const userStoreController = new UserStoreController(userService, cuscomService, {
  getMarketCustomer: async () => {
    return MMCoreBffClient.getMarketCustomer().then(mapMarketCustomer);
  },
});

onAuth(() => {
  userStoreController.fetchUser().then(() => {
    const { trackAuthSuccess } = useAuthTracker();
    trackAuthSuccess();
  });
});

onInit(({ isAuthorized }) => {
  if (isAuthorized) {
    userStoreController.fetchUser();
  } else {
    userStoreController.clearUser();
  }
});

onLogout(() => {
  userStoreController.clearUser();
});

async function registerProfile(profile: IUserMM, magnitIdCode: string) {
  return await userStoreController.registerProfile(profile, magnitIdCode);
}

async function updateProfile(profile: IUserMM) {
  return await userStoreController.updateProfile(profile);
}

async function setNotifications() {
  await userStoreController.setNotifications();
}

const { createPopup } = usePopups();
const profileFillPopup = createPopup({
  component: FillProfilePopup,
});

const isRequiredFieldsFilled = computed(() => userStoreController.isRequiredFieldsFilled);
function fillProfileIfNeeded() {
  if (!isRequiredFieldsFilled.value) {
    profileFillPopup.show();
  }
}

function closeProfileFillPopup() {
  profileFillPopup.close();
}

const isUserDataFetched = userStoreController.isUserDataFetched;

function confirmAdult(isAdult: boolean) {
  userStoreController.confirmAdult(isAdult);
}

const isAdultChecked = computed(() => userStoreController.isAdultChecked);
const isAdult = computed(() => userStoreController.isAdult);  

export function useUserStore() {
  const profile = computed(() => userStoreController.getUser());

  return {
    profile,
    registerProfile,
    updateProfile,
    setNotifications,
    fillProfileIfNeeded,
    closeProfileFillPopup,
    isRequiredFieldsFilled,
    isUserDataFetched,
    marketCustomer: userStoreController.marketCustomer,
    confirmAdult,
    isAdultChecked,
    isAdult,
  };
}
